import CanvasJSReact_ReportDaily from '../chart/Chart_ReportDaily';

import {
    getErrText,
    getErrColor,
    createdata_row
} from "./library"

import './bee-print-daily.css';

function SiteReportDaily({ reportdata, reportchart }) {
    return (
        <div className='report-wrapper'>
            <div className="page-vertical rp-daily" >
                <div className="document-header">
                    <div className="document-logo-left">
                        <img src="/images/ReportLogoleft.bmp" className="logo" style={{ opacity: "1" }} alt='logo-left1' />
                    </div>
                    <div className="document-logo-right">
                        {/* <img src="/images/ReportLogoright.bmp" className="logo" style={{ opacity: "1" }} alt='logo-right1' /> */}
                        <div className="company-box">
                            SHINING SPV 1 CO., LTD.
                        </div>
                    </div>

                    <label className="document-type">Daily Report</label>
                    <label className="document-date" id="data-daily-header-reportdate">{reportdata.Header?.ReportDate}</label>
                    <label className="document-sitelocation" id="data-daily-header-sitename">{reportdata.Header?.SiteName}</label>
                    <label className="document-pages">Pages 1/1</label>

                    {
                        reportdata.Header?.total_meter === 1 ?
                            <div className="document-meterupdate">
                                <div className="container">
                                    <label>Up to Date</label>
                                    <span className='font-sarabun' id="data-daily-header-uptodate">{reportdata?.Header?.MeterUpdate1}</span>
                                    <span className="totalunit"> kWh</span>
                                </div>
                            </div>
                            :
                            null
                    }

                    <div className="document-capacity">
                        <div className="container">
                            <label>Capacity</label>
                            <span className='font-sarabun' id="data-daily-header-capacity">{reportdata.Header?.Capacity}</span>
                            <span className="totalunit">kWp</span>
                        </div>
                    </div>

                    <div className="document-area">
                        <div className="container">
                            <label>Area</label>
                            <span className='font-sarabun' id="data-daily-header-area">{reportdata.Header?.Area}</span>
                            <span className="totalunit">m<sup>2</sup></span>
                        </div>
                    </div>
                </div>

                <div className="document-info">
                    <div className="document-info1">
                        <div className="container">
                            <label>Energy Consumption</label>
                            <span className='font-sarabun' id="data-daily-info-energyconsumption">{reportdata.Info?.EnergyConsumption}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                        <div className="container">
                            <label>Energy from Grid (All Day)</label>
                            <span className='font-sarabun' id="data-daily-info-energygrid">{reportdata.Info?.EnergyGrid}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                        <div className="container">
                            <label>Energy from Solar {reportdata.Header?.SolarType}</label>
                            <span className={'font-sarabun ' + getErrColor(reportdata.FlagSolar)} id="data-daily-info-energysolar">{reportdata.Info?.EnergySolar}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                        <div className="container">
                            <label>Energy from Solar, On-Peak</label>
                            <span className='font-sarabun ' id="data-daily-info-energysolar-onpeak">{reportdata.Info?.EnergySolar_OnPeak}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                        <div className="container">
                            <label>Energy from Solar, Off-Peak</label>
                            <span className='font-sarabun ' id="data-daily-info-energysolar-offpeak">{reportdata.Info?.EnergySolar_OffPeak}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                    </div>

                    <div className="document-info2">
                        <div className="container">
                            <label>Energy not Supply</label>
                            <span id="data-daily-info-ens" className={'font-sarabun ' + getErrColor(reportdata.FlagENS)}>{getErrText(reportdata.FlagENS, reportdata.Info?.ENS)}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                        <div className="container">
                            <label>CO<sub>2</sub> Reduction</label>
                            <span className='font-sarabun' id="data-daily-info-co2">{reportdata.Info?.CO2}</span>
                            <span className="totalunit">kgCO<sub>2</sub></span>
                        </div>
                        <div className="container">
                            <label>PR</label>
                            <span id="data-daily-info-prens" className={'font-sarabun ' + getErrColor(reportdata.FlagPRENS)}>{getErrText(reportdata.FlagPRENS, reportdata.Info?.PR_ENS)}</span>
                            <span className="totalunit">%</span>
                        </div>
                        <div className="container">
                            <label>PR (Not ENS)</label>
                            <span id="data-daily-info-pr" className={'font-sarabun ' + getErrColor(reportdata.FlagPR)}>{getErrText(reportdata.FlagPR, reportdata.Info?.PR)}</span>
                            <span className="totalunit">%</span>
                        </div>
                        <div className="container">
                            <label>OR</label>
                            <span id="data-daily-info-or" className={'font-sarabun ' + getErrColor(reportdata.FlagOR)}>{getErrText(reportdata.FlagOR, reportdata.Info?.ORX_ENS)}</span>
                            <span className="totalunit">%</span>
                        </div>
                    </div>

                    <div className="document-info3">
                        <div className="container">
                            <label>Solar Avai.</label>
                            <span className='font-sarabun' id="data-daily-info-solaravi">{reportdata.Info?.AVI}</span>
                            <span className="totalunit">%</span>
                        </div>
                        <div className="container">
                            <label>Irradiance</label>
                            <span id="data-daily-info-irr" className={'font-sarabun ' + getErrColor(reportdata.FlagIRR)}>{getErrText(reportdata.FlagIRR, reportdata.Info?.IRR)}</span>
                            <span className="totalunit">Wh/m<sup>2</sup></span>
                        </div>
                        <div className="container">
                            <label>Irradiance (max)</label>
                            <span id="data-daily-info-irrmax" className={'font-sarabun ' + getErrColor(reportdata.FlagIRR)}>{getErrText(reportdata.FlagIRR, reportdata.Info?.IRRMax)}</span>
                            <span className="totalunit">W/m<sup>2</sup></span>
                        </div>
                        <div className="container">
                            <label>Module Temp (max)</label>
                            <span id="data-daily-info-tempmax" className={'font-sarabun ' + getErrColor(reportdata.FlagTempModule)}>{getErrText(reportdata.FlagTempModule, reportdata.Info?.ModuleTempMax)}</span>
                            <span className="totalunit">°C</span>
                        </div>
                    </div>
                </div>


                <div className="itemtable">
                    <table className="tablex table-hover table-daily" id="table-daily-report">
                        <thead className="table-header">
                            <tr className="r1">
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2" id="cDate">Hour</th>
                                <th className="horizinton-align-center bottom-black-line" colSpan="2">
                                    Irradiance</th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">Ambient Temp. <p>(°C)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">Module Temp. <p>(°C)</p>
                                </th>
                                {
                                    reportdata.has_windspeed === true ?
                                        <th className="horizinton-align-center bottom-black-line" rowSpan="2">Wind Speed <p>(m/s)</p>
                                        </th>
                                        :
                                        null
                                }
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">DC Energy <p>(kWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">AC Energy <p>(kWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">ENS <p>(kWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">Energy from Grid <p>(kWh)</p>
                                </th>
                            </tr>
                            <tr className="r2">
                                <th className="horizinton-align-center bottom-black-line">
                                    (Wh/m<sup>2</sup>)</th>
                                <th className="horizinton-align-center bottom-black-line">
                                    (Wmax/m<sup>2</sup>)</th>
                            </tr>
                        </thead>
                        <tbody className="topics" >
                            {
                                reportdata.TableData?.map((data, index) => (
                                    <tr key={"data-daily-H" + index}>
                                        <td align="center" className="item col-rx-black">{data.Datex}</td>
                                        {createdata_row(data.FlagIRR, data.IRR, data.CODStatus)}
                                        {createdata_row(data.FlagIRR, data.IRRMax, data.CODStatus)}
                                        {createdata_row(data.FlagTempAmbient, data.AmbientTemp, data.CODStatus)}
                                        {createdata_row(data.FlagTempModule, data.ModuleTemp, data.CODStatus)}
                                        {
                                            reportdata.has_windspeed === true ?
                                                createdata_row("", data.WindSpeed, data.CODStatus)
                                                :
                                                null
                                        }
                                        {createdata_row("", data.EnergyDC, data.CODStatus)}
                                        {createdata_row(data.FlagSolar, data.EnergyAC, data.CODStatus)}
                                        {createdata_row(data.FlagENS, data.ENS, data.CODStatus)}
                                        {createdata_row(data.FlagGrid, data.EnergyGrid, data.CODStatus)}
                                    </tr>
                                ))
                            }
                            <tr className="summary" id="data-daily-summary">
                                <td align="center" className="item col-rx-black">Total</td>
                                {createdata_row(reportdata.FlagIRR, reportdata.Summary?.IRR, true)}
                                {createdata_row(reportdata.FlagIRR, reportdata.Summary?.IRRMax, true)}
                                {createdata_row(reportdata.FlagTempAmbient, reportdata.Summary?.AmbientTemp, true)}
                                {createdata_row(reportdata.FlagTempModule, reportdata.Summary?.ModuleTemp, true)}
                                {
                                    reportdata.has_windspeed === true ?
                                        createdata_row("", reportdata.Summary?.WindSpeed, true)
                                        :
                                        null
                                }
                                {createdata_row("", reportdata.Summary?.EnergyDC, true)}
                                {createdata_row(reportdata.FlagSolar, reportdata.Summary?.EnergyAC, true)}
                                {createdata_row(reportdata.FlagENS, reportdata.Summary?.ENS, true)}
                                {createdata_row("", reportdata.Summary?.EnergyGrid, true)}
                            </tr>
                        </tbody>
                    </table>
                </div>
                <label className="refference-remark">Remark</label>
                <div className="refference-remark1 font-sarabun">
                    <div className="container">
                        <label>PR<sub>G</sub></label>
                        <span className='font-sarabun' id="data-daily-ref-prg">{reportdata.Refference?.PRG}</span>
                        <span className="totalunit">%</span>
                    </div>
                    <div className="container">
                        <label>OR<sub>G</sub></label>
                        <span className='font-sarabun' id="data-daily-ref-org">{reportdata.Refference?.ORG}</span>
                        <span className="totalunit">%</span>
                    </div>
                    <div className="container">
                        <label>@#Yr.</label>
                        <span className='font-sarabun' id="data-daily-ref-year">{reportdata.Refference?.YR}</span>
                        <span className="totalunit"></span>
                    </div>
                </div>

                <div className="refference-remark2 font-sarabun">
                    <div className="container ">
                        <label>STC </label>
                        <span className='font-sarabun' id="data-daily-ref-stc">{reportdata.Refference?.STC}</span>
                        <span className="totalunit">%</span>
                    </div>
                    <div className="container">
                        <label>1kWh = </label>
                        <span className='font-sarabun' id="data-daily-ref-co2">{reportdata.Refference?.Factor_CO2}</span>
                        <span className="totalunit">kgCO<sub>2</sub></span>
                    </div>
                </div>

                {
                    reportdata.Header?.total_meter > 1 ?
                        <div className="refference-remark3 font-sarabun">
                            <div className="container">
                                <label>Meter 1 Acc.</label>
                                <span className='font-sarabun' >{reportdata.Header?.MeterUpdate1}</span>
                                <span className="totalunit">kWh</span>
                            </div>
                            {
                                reportdata.Header?.total_meter > 1 ?
                                    <div className="container">
                                        <label>Meter 2 Acc.</label>
                                        <span className='font-sarabun'>{reportdata.Header?.MeterUpdate2}</span>
                                        <span className="totalunit">kWh</span>
                                    </div>
                                    :
                                    null
                            }
                            {
                                reportdata.Header?.total_meter > 2 ?
                                    <div className="container">
                                        <label>Meter 3 Acc.</label>
                                        <span className='font-sarabun' >{reportdata.Header?.MeterUpdate3}</span>
                                        <span className="totalunit">kWh</span>
                                    </div>
                                    :
                                    null
                            }
                        </div>
                        :
                        null
                }

                <div className="chart-daily-wrapper">
                    <label className="left-y" id="daily-left-y" style={{ left: "36px" }}>kW</label>
                    <label className="right-y" id="daily-right-y" style={{ left: "712px" }}>W/m<sup>2</sup></label>
                    <div className="chx" id="trend-daily" style={{ height: "326px", width: "100%" }}>
                        <CanvasJSReact_ReportDaily
                            info={reportdata.Header}
                            xlabel={reportchart.XLabel}
                            solorpower={reportchart.EnergyAC}
                            gridpower={reportchart.EnergyGrid}
                            ens={reportchart.ENS}
                            irr={reportchart.IRR}
                        ></CanvasJSReact_ReportDaily>
                    </div>
                </div>

                <div className="doc-remark">
                    <label className="generate-remark1" id="generate-daily-print1">Printed Date : {reportdata.Header?.PrintDate}</label>
                    <label className="generate-remark2">* This reports have been generated by CPF solar monitoring system local web
                        application. *</label>
                </div>
            </div>
        </div>
    )
}
export default SiteReportDaily